<script lang="ts" setup>
  import { StatusBanner } from '../../../shared/ui/status-banner';
  import { settingsSaveError } from '../model/settingsSaving.ts';
</script>

<template>
  <StatusBanner v-if="settingsSaveError" role="alert">{{ settingsSaveError }}</StatusBanner>
</template>
